import React, { useState } from "react";
import { Box, Stack, Button } from "@curves/ui-base";
import MobileCarrierBarCode from "@icoach/components/barCode/MobileCarrierBarCode";
import MobileCarrierBarCodeDialog from "@icoach/components/barCode/MobileCarrierBarCodeDialog";

const MobileCarrierBarCodeTestPage = React.forwardRef((props, ref) => {
	const [open, setOpen] = useState(false);

	return (
		<Box className="main-container-spacing">
			<Stack direction="column" spacing={3}>
				<MobileCarrierBarCode hasButton={true} />
				<Box>
					<Button variant="outlined" onClick={() => setOpen(true)}>
						開啟掃描視窗
					</Button>
				</Box>
			</Stack>
			<MobileCarrierBarCodeDialog open={open} onClose={() => setOpen(false)} />
		</Box>
	);
});

export default MobileCarrierBarCodeTestPage;
